import { render, staticRenderFns } from "./CoolingChamberAdmi.vue?vue&type=template&id=8d443d2a&scoped=true"
import script from "./CoolingChamberAdmi.vue?vue&type=script&lang=js"
export * from "./CoolingChamberAdmi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d443d2a",
  null
  
)

export default component.exports